/* ============================================================
   SpecWorks Custom — Site-wide scripts (Shopify theme)
   ============================================================
   Reads window.SPECWORKS_CONFIG (injected by layout/theme.liquid)
   for: whatsapp number, cart count, page context.
   Wires up: theme toggle, hamburger menu w/ focus trap, WhatsApp FAB,
   sticky header scrolled state, optimistic cart-count helper.
   Header markup itself lives in sections/header.liquid (not JS).
   ============================================================ */

/* Theme bootstrap — runs BEFORE DOMContentLoaded to avoid flash.
   Default is ALWAYS dark. User can opt into light mode via the toggle;
   their choice persists in localStorage. */
(function bootstrapTheme(){
  try {
    var saved = localStorage.getItem('sw-theme');
    var theme = saved === 'light' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', theme);
  } catch(e) {
    document.documentElement.setAttribute('data-theme', 'dark');
  }
})();

(function(){
  var CFG = window.SPECWORKS_CONFIG || {};
  var current = (document.body && document.body.dataset.page) || '';

  // ---------- Sticky header scrolled state ----------
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function(){
      if (window.scrollY > 12) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  }

  // ---------- Hamburger menu controls (with focus trap — WCAG 2.1.2 / 2.4.3) ----------
  var menuTrigger = document.getElementById('menuTrigger');
  var menuOverlay = document.getElementById('menuOverlay');
  var menuClose = document.getElementById('menuClose');
  var lastFocusBeforeMenu = null;

  function getMenuFocusables() {
    if (!menuOverlay) return [];
    return Array.prototype.slice.call(
      menuOverlay.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
  }

  function openMenu() {
    if (!menuOverlay) return;
    lastFocusBeforeMenu = document.activeElement;
    menuOverlay.hidden = false;
    requestAnimationFrame(function(){ menuOverlay.classList.add('is-open'); });
    document.body.classList.add('menu-locked');
    if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'true');
    setTimeout(function(){ if (menuClose) menuClose.focus(); }, 50);
  }
  function closeMenu() {
    if (!menuOverlay) return;
    menuOverlay.classList.remove('is-open');
    document.body.classList.remove('menu-locked');
    if (menuTrigger) menuTrigger.setAttribute('aria-expanded', 'false');
    setTimeout(function(){ menuOverlay.hidden = true; }, 400);
    if (lastFocusBeforeMenu && typeof lastFocusBeforeMenu.focus === 'function') {
      lastFocusBeforeMenu.focus();
    }
  }

  if (menuTrigger) menuTrigger.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e){
    if (!menuOverlay || menuOverlay.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeMenu();
      return;
    }
    if (e.key === 'Tab') {
      var focusables = getMenuFocusables();
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // ---------- Theme toggle (light/dark) ----------
  var themeToggle = document.getElementById('themeToggle');
  function setTheme(t){
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem('sw-theme', t); } catch(e){}
  }
  function toggleTheme(){
    var cur = document.documentElement.getAttribute('data-theme') || 'dark';
    setTheme(cur === 'dark' ? 'light' : 'dark');
  }
  if (themeToggle) themeToggle.addEventListener('click', toggleTheme);

  // ---------- WhatsApp floating action button ----------
  var WA_PHONE = (CFG.whatsappNumber || '525500000000').toString().replace(/[^0-9]/g, '');
  var pageContextMap = {
    home:      'la página principal',
    servicios: 'Servicios',
    catalogo:  'Catálogo',
    cotizador: 'Cotizador',
    producto:  'una pieza del catálogo',
    carrito:   'Carrito'
  };
  function buildWAUrl(){
    var ctx = pageContextMap[current] || 'el sitio';
    var msg = CFG.whatsappMessage || ('Hola SpecWorks — necesito una pieza.\n\nVengo de: ' + ctx);
    return 'https://wa.me/' + WA_PHONE + '?text=' + encodeURIComponent(msg);
  }
  function renderWAFab(){
    return [
      '<a href="' + buildWAUrl() + '" class="wa-fab" target="_blank" rel="noopener" aria-label="Cotizar por WhatsApp">',
      '  <svg viewBox="0 0 24 24" aria-hidden="true">',
      '    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>',
      '  </svg>',
      '  <span class="wa-fab-label">WhatsApp</span>',
      '</a>'
    ].join('\n');
  }
  if (!document.querySelector('.wa-fab')) {
    var waMount = document.createElement('div');
    waMount.innerHTML = renderWAFab();
    document.body.appendChild(waMount.firstElementChild);
  }

  // ---------- Cart count — source of truth is Shopify ({{ cart.item_count }}) ----------
  // Liquid injects window.SPECWORKS_CONFIG.cartCount on every page load.
  // setCartCount is kept as an optimistic UI update; the real count is reconciled
  // on next page load. Wired to Cart AJAX API in Fase 3.
  function paintCart(n){
    var el = document.getElementById('cartCount');
    if (!el) return;
    el.textContent = String(n);
    el.setAttribute('data-count', String(n));
  }

  window.SpecWorks = window.SpecWorks || {};
  window.SpecWorks.getCartCount = function(){
    return typeof CFG.cartCount === 'number' ? CFG.cartCount : 0;
  };
  window.SpecWorks.setCartCount = function(n){
    paintCart(Math.max(0, parseInt(n, 10) || 0));
  };
  window.SpecWorks.clearCart = function(){ paintCart(0); };
  window.SpecWorks.getWhatsAppUrl = buildWAUrl;

  // Initial paint from Shopify-provided count
  paintCart(window.SpecWorks.getCartCount());

  // ---------- Scroll reveal (global) ----------
  // Any element with class .reveal fades in when 15% visible.
  // Runs on every page so home/PDP/catalog/cart/etc behave consistently.
  if ('IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll('.reveal');
    if (revealTargets.length) {
      var revealIO = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            revealIO.unobserve(en.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach(function(el){ revealIO.observe(el); });
    }
  } else {
    // Fallback: if no IntersectionObserver, just show everything immediately
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }
})();
